import request from "@/utils/request";
export function runningCluster(data) {
    return request({
        url: "/native/is_cluster_running",
        method: "GET",
        params: data
    });
}
export function clusterOverview(data) {
    return request({
        url: "/resource/region_resouce_overview",
        method: "GET",
        params: data
    });
}
export function clusterList(data) {
    return request({
        url: "/native/cluster_list",
        method: "GET",
        params: data
    });
}
export function clusterDetail(data) {
    return request({
        url: "/native/cluster",
        method: "GET",
        params: data
    });
}
export function delCluster(data) {
    return request({
        url: "/native/cluster",
        method: "DELETE",
        params: data
    });
}
export function clusterQuota(data) {
    return request({
        url: "/native/cluster",
        method: "PUT",
        data
    });
}
export function createCluster(data) {
    return request({
        url: "/native/cluster",
        method: "POST",
        data
    });
}
export function namespaces(data) {
    return request({
        url: "/native/namespaces",
        method: "GET",
        params: data
    });
}
export function storageList(data) {
    return request({
        url: "/native/shared_storages",
        method: "GET",
        params: data
    });
}
export function storageStatus(data) {
    return request({
        url: "/native/shared_storages/status",
        method: "GET",
        params: data
    });
}
export function sharedStorage(data) {
    return request({
        url: "/native/shared_storages",
        method: "PUT",
        data
    });
}
export function createStorage(data) {
    return request({
        url: "/native/shared_storages",
        method: "POST",
        data
    });
}
export function deleteStorage(data) {
    return request({
        url: "/native/shared_storages",
        method: "DELETE",
        data
    });
}
export function tokenList(data) {
    return request({
        url: "/native/access_tokens",
        method: "GET",
        params: data
    });
}
export function kubeConfig(data) {
    return request({
        url: "/native/access_tokens/kube_config",
        method: "GET",
        params: data
    });
}
export function createToken(data) {
    return request({
        url: "/native/access_tokens",
        method: "POST",
        data
    });
}
export function deleteToken(data) {
    return request({
        url: "/native/access_tokens",
        method: "DELETE",
        data
    });
}
export function createssh(data) {
    return request({
        url: "/native/ssh_servers",
        method: "POST",
        data
    });
}
export function createContainerServer(data) {
    return request({
        url: "/native/container_servers",
        method: "POST",
        data
    });
}
export function createContainerServerV2(data) {
    return request({
        url: "/native/container_servers_v2",
        method: "POST",
        data
    });
}
export function updateContainerServer(data) {
    return request({
        url: "/native/container_servers/change_config",
        method: "PUT",
        data
    });
}
export function getContainerServer(data) {
    return request({
        url: "/native/container_servers/detail",
        method: "GET",
        params: data
    });
}
export function serverList(data) {
    return request({
        url: "/native/container_servers/list",
        method: "GET",
        params: data
    });
}
export function amountStatus() {
    return request({
        url: "/billing/userAmountStatus",
        method: "GET"
    });
}
export function switchServer(data) {
    return request({
        url: "/native/ssh_servers/power",
        method: "PUT",
        data
    });
}
export function switchContainerServer(data) {
    return request({
        url: "/native/container_servers/power",
        method: "PUT",
        data
    });
}
export function saveImage(data) {
    return request({
        url: "/native/container_servers/save_image",
        method: "PUT",
        data
    });
}
export function setdocker(data) {
    return request({
        url: "/native/container_servers/enable_docker",
        method: "PUT",
        data
    });
}
export function publicIp(data) {
    return request({
        url: "/native/ssh_servers/public_ip",
        method: "PUT",
        data
    });
}
export function deleteServer(data) {
    return request({
        url: "/native/ssh_servers",
        method: "DELETE",
        data
    });
}
export function deleteContainerServer(data) {
    return request({
        url: "/native/container_servers",
        method: "DELETE",
        data
    });
}
export function sshflavors(data) {
    return request({
        url: "/native/ssh_servers/flavors",
        method: "GET",
        params: data
    });
}
export function getClusterQuota() {
    return request({
        url: "/native/cluster_quota",
        method: "GET"
    });
}
export function updateClusterGroup(data) {
    return request({
        url: "/native/cluster_group",
        method: "PUT",
        data
    });
}
export function quotaLimit(data) {
    return request({
        url: "/native/quota_limit",
        method: "GET",
        params: data
    });
}
export function storageType(data) {
    return request({
        url: "/resource/specifications",
        method: "GET",
        params: data
    });
}
export function enableSpot(data) {
    return request({
        url: "/native/priority/enableSpot",
        method: "PUT",
        data
    });
}
export function disableSpot(data) {
    return request({
        url: "/native/priority/disableSpot",
        method: "PUT",
        data
    });
}
export function queneList(data) {
    return request({
        url: "/workloads/list",
        method: "GET",
        params: data
    });
}
export function queneDetail(data) {
    return request({
        url: "/workloads/detail",
        method: "GET",
        params: data
    });
}
export function specificationIndex(data) {
    return request({
        url: "/native/container_servers/specification_index",
        method: "GET",
        params: data
    });
}
export function cmdTemplate() {
    return request({
        url: "/native/images/custom/cmd_template",
        method: "GET"
    });
}
export function cronShutdown(data) {
    return request({
        url: "/native/container_servers/cron_shutdown",
        method: "PUT",
        data
    });
}
export function shutdownMoney(data) {
    return request({
        url: "/native/container_servers/cron_shutdown_consumption_check",
        method: "GET",
        params: data
    });
}
export function paymomentData(data) {
    return request({
        url: "/native/cluster/support",
        method: "POST",
        data
    });
}
export function sshEvents(data) {
    return request({
        url: "/native/container_servers/events",
        method: "POST",
        data
    });
}
export function mirrorLog(data) {
    return request({
        url: "/native/container_servers/save_image/logs",
        method: "POST",
        data
    });
}
export function stopMirror(data) {
    return request({
        url: "/native/container_servers/save_image/stop",
        method: "PUT",
        data
    });
}
// 查询集群配额上限设置
export function quotaApplyLimits(data) {
    return request({
        url: "/user/cluster/quota_apply/status",
        method: "GET",
        params: data
    });
}
export function quotaApply(data) {
    return request({
        url: "/user/cluster/quota_apply",
        method: "POST",
        data
    });
}
export function getClusterInfo() {
    return request({
        url: "/user/cluster/count_apply/status",
        method: "GET"
    });
}
export function setClusterApply(data) {
    return request({
        url: "/user/cluster/count_apply",
        method: "POST",
        data
    });
}
export function gpuDrivers(data) {
    return request({
        url: "/resource/region/available_gpu_drivers",
        method: "GET",
        params: data
    });
}
